import state from './certificateState.js'
import mutations from './certificateMutations'
import actions from './certificateActions'
import getters from './certificateGetters'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
